export default __webpack_public_path__ + "static/media/waffer.d8a630b0.png";